import * as React from "react";
import {useState, useRef} from "react";
import {uploadImage} from "../service/ImageService";
import {Alert, ProgressBar} from "react-bootstrap";
import {Button} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";


export default function ImageUpload({images, setImages, prepareUpload}) {
    const [isUploading, setIsUploading] = useState(false);
    const [uploadPercentage, setUploadPercentage] = useState(0);
    const [fileCount, setFileCount] = useState(0);
    const fileInputRef = useRef(null);

    function delayOneSecond() {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 1000);
        });
    }

    const handleUpload = async (newValue) => {
        let pendingImages = [];
        const progressArray = new Array(newValue.length).fill(0);

        setIsUploading(true);
        setFileCount(newValue.length);

        const updateTotalProgress = () => {
            const totalProgress = progressArray.reduce((acc, curr) => acc + curr, 0) / newValue.length;
            const totalProgressRounded = Number(totalProgress.toFixed(2));
            setUploadPercentage(totalProgressRounded);
        };

        await Promise.all(newValue.map(async (file, index) => {
            const fileType = file?.type?.split("/")[1]?.toLowerCase() || "unknown";
            const fileName = file?.name || "unknown";

            await prepareUpload(fileName, fileType).then(async (response) => {
                if (response.status === 200) {
                    let data = await response.json();
                    let signedUrl = data.upload_url;

                    await uploadImage(signedUrl, file, (percentage) => {
                        progressArray[index] = percentage;
                        updateTotalProgress();
                    });

                    pendingImages.push(data);
                } else {
                    console.error(response);
                }
            });
        }));

        setFileCount(0);
        setIsUploading(false);
        setUploadPercentage(0);
        delayOneSecond().then(() => {
            setImages([...images, ...pendingImages]);
        });
    };


    return (
        <>
            <input
                ref={fileInputRef}
                type="file"
                accept="image/*, video/*, application/pdf"
                multiple
                hidden
                onChange={(e) => {
                    const fileList = Array.from(e.target.files);
                    if (fileList.length > 0) handleUpload(fileList);
                    e.target.value = "";
                }}
            />
            <Button
                variant="outlined"
                fullWidth
                size="small"
                disabled={isUploading}
                startIcon={<AttachFileIcon />}
                onClick={() => fileInputRef.current?.click()}
                sx={{mt: 1, justifyContent: "flex-start", textTransform: "none", color: "text.secondary"}}
            >
                {fileCount > 0 ? `${fileCount} file(s) selected` : "Click to Insert your images"}
            </Button>
            {isUploading &&
                <Alert key={"primary"} variant={"primary"}>
                    <ProgressBar animated now={uploadPercentage} label={`${uploadPercentage}%`}/>
                    Uploading...Please wait
                </Alert>
            }
        </>
    )
}
